import { generateMedia } from "styled-media-query";

const media = generateMedia({
  desktop: "992px",
  tablet: "768px",
  phone: "576px",
});

export default media;
